export const NAMESPACE = 'flashMessage';
